document.addEventListener('change', (event) => {
  if (!event.target.matches('[data-collection-sort]')) return;
  const url = new URL(window.location.href);
  url.searchParams.set('sort_by', event.target.value);
  url.searchParams.delete('page');
  window.location.assign(url.toString());
});

document.addEventListener('click', async (event) => {
  const showFilters = event.target.closest('[data-facets-show]');
  if (showFilters) {
    const sidebarToggle = showFilters.closest('.collection-listing')?.querySelector('[data-facets-sidebar-toggle]');
    sidebarToggle?.click();
    sidebarToggle?.focus();
    return;
  }
  const closeFilter = event.target.closest('[data-mobile-filter-close]');
  if (closeFilter) {
    const drawer = closeFilter.closest('menu-drawer');
    const opener = drawer?.mainDetailsToggle?.querySelector('summary');
    drawer?.closeMenuDrawer(event, opener);
    opener?.setAttribute('aria-expanded', 'false');
    return;
  }
  const toggle = event.target.closest('[data-facets-sidebar-toggle]');
  if (toggle) {
    const collapsed = toggle.closest('form').classList.toggle('facets-sidebar-collapsed');
    toggle.closest('.facets-vertical')?.classList.toggle('collection-filters-collapsed', collapsed);
    toggle.setAttribute('aria-expanded', String(!collapsed));
    toggle.querySelector('span').textContent = collapsed ? 'Mostrar filtros' : 'Ocultar';
    if (collapsed) {
      const restore = toggle.closest('.collection-listing')?.querySelector('[data-facets-show]');
      if (restore && restore.getClientRects().length) restore.focus();
    }
    return;
  }
  const back = event.target.closest('[data-collection-back]');
  if (back && document.referrer && new URL(document.referrer).origin === location.origin) {
    event.preventDefault();
    history.back();
    return;
  }
  const share = event.target.closest('[data-collection-share]');
  if (!share) return;
  const status = share.nextElementSibling;
  try {
    if (navigator.share) await navigator.share({ title: document.title, url: location.href });
    else {
      await navigator.clipboard.writeText(location.href);
      status.textContent = 'Link copiado';
    }
  } catch (error) {
    if (error.name !== 'AbortError') status.textContent = 'Não foi possível compartilhar o link.';
  }
});
